import { CommandProps, NodeViewProps } from '@tiptap/core'
import ListItem from '@tiptap/extension-list-item'
import {
  NodeViewContent,
  NodeViewWrapper,
  ReactNodeViewRenderer,
} from '@tiptap/react'
import React from 'react'

export const CustomListItemExtension = ListItem.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      icon: {
        default: null,
      },
    }
  },

  addCommands() {
    return {
      ...this.parent?.(),
      setCustomListIcon:
        (icon: string) =>
        ({ tr, state, dispatch }: CommandProps) => {
          const { doc } = state

          doc.descendants((node, pos) => {
            if (node.type.name === 'listItem') {
              tr.setNodeAttribute(pos, 'icon', icon)
            }
          })

          if (dispatch) {
            dispatch(tr)
          }

          return true
        },
    }
  },

  addKeyboardShortcuts() {
    return {
      ...this.parent?.(),
      Enter: ({ editor }) => {
        const { state } = editor
        const { $from } = state.selection

        const node = $from.node()
        const parentNode = $from.node($from.depth - 1)

        const isEmptyParagraph =
          node.type.name === 'paragraph' && node.textContent.trim() === ''
        const isEmptyListItem =
          parentNode.type.name === 'listItem' &&
          parentNode.textContent.trim() === ''

        if (isEmptyParagraph && isEmptyListItem) {
          const icon =
            typeof editor.options.editorProps.attributes === 'function'
              ? editor.options.editorProps.attributes(editor.state)?.[
                  'iconClassName'
                ]
              : editor.options.editorProps.attributes?.['iconClassName']

          editor
            .chain()
            .focus()
            .insertContent({
              type: 'listItem',
              attrs: { icon },
              content: [
                {
                  type: 'paragraph',
                  text: '',
                },
              ],
            })
            .run()

          return true
        }

        return false
      },
    }
  },
  addNodeView() {
    return ReactNodeViewRenderer(CustomListItemComponent)
  },
})

const CustomListItemComponent = ({ node, ...rest }: NodeViewProps) => {
  const attributes = rest.editor.options.editorProps.attributes
  let iconClassName = ''

  if (typeof attributes === 'function') {
    iconClassName = attributes(rest.editor.state)?.iconClassName
  } else if (attributes && typeof attributes === 'object') {
    iconClassName = (attributes as { [name: string]: string }).iconClassName
  }

  const icon = node.attrs.icon || iconClassName

  const direction = node.attrs.dir
  const rtlStyles = direction === 'rtl' ? { gap: '30px' } : {}
  return (
    <NodeViewWrapper
      as="li"
      dir={direction}
      style={{ display: 'flex', alignItems: 'stretch', ...rtlStyles }}
    >
      <i className={icon} style={{ lineHeight: 'inherit' }} />
      <NodeViewContent style={{ minWidth: '1px' }} />
    </NodeViewWrapper>
  )
}
